<script setup>
import {useForm} from '@inertiajs/vue3';
import {inject} from 'vue';

// Components
import Card from '@/Components/Card.vue';
import Pagination from '@/Components/Pagination.vue';
import ResourceCategoriesFilter from '@/Components/ResourceCategoriesFilter.vue';
import {useDebounceFn} from '@vueuse/core';

const props = defineProps({
    query: Object,
    title: String,
    blogs: Object,
    blogCategories: Object,
    amount_blogs: String,
});

const route = inject('route');

const form = useForm({
    page: props.blogs?.page ?? 1,
    search: props.query?.search ?? '',
    categories: props.query?.categories ?? [],
});

const submit = (resetPage = true) => {
    console.log('submit');
    form.page = resetPage ? 1 : form.page;
    form.get(route('public.blogs.index'), {
        preserveState: true,
    });
};

const setPage = (e) => {
    form.page = e;
    submit(false);
};

const search = useDebounceFn(() => {
    submit();
}, 300);
</script>

<template>
    <div class="bg-gray-lighter">
        <div class="container py-12 md:py-16">
            <h2
                v-if="title"
                class=""
                v-html="title"
            />

            <FormKit
                v-if="parseInt(amount_blogs) === 16"
                v-model="form.search"
                :errors="form.errors.search"
                :label="$t('Search')"
                :value="form.search"
                name="search"
                suffix-icon="search"
                type="search"
                @input="search"
            />

            <div class="mb-12">
                <ResourceCategoriesFilter
                    v-if="blogCategories && amount_blogs === '16'"
                    v-model="form.categories"
                    :categories="blogCategories"
                    :href="route('public.blogs.index')"
                    :query="query"
                    @update:model-value="submit"
                />
            </div>

            <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
                <article
                    v-for="blog in blogs.data"
                    :key="blog.id"
                    class="' flex flex-col rounded-xl bg-white"
                >
                    <Card
                        :href="route('public.blogs.show', { slug: blog.page_slug })"
                        :type="blog"
                    />
                </article>
            </div>

            <Pagination
                v-if="parseInt(amount_blogs) === 16"
                :links="blogs.links"
                :page-data="blogs"
                @set-page="setPage"
            />
        </div>
    </div>
</template>
